export default class WCArchiveDateWidget {
    constructor() {
        this.widgetDateForm = document.querySelector('.jsSidebarDateForm');

        if (this.widgetDateForm) {
            this.widgetDateFormInputs = [
                ...this.widgetDateForm.querySelectorAll(
                    '.jsSidebarDateFormInput',
                ),
            ];
            this.widgetDateFormLabels = [
                ...this.widgetDateForm.querySelectorAll(
                    '.jsSidebarDateFormLabel',
                ),
            ];

            this.events();
        }
    }

    events() {
        if (this.widgetDateFormInputs.length) {
            this.widgetDateFormInputs.forEach((input) =>
                this.handleDateInputChange(input),
            );

            this.widgetDateFormInputs.forEach((input) =>
                input.addEventListener('click', () => {
                    try { input.showPicker(); } catch (e) {}
                }),
            );

            this.widgetDateFormInputs.forEach((input) =>
                input.addEventListener('change', (e) => {
                    const clickedInput = e.currentTarget;

                    this.handleDateInputChange(clickedInput);
                }),
            );
        }
    }

    handleDateInputChange(input) {
        if (!input) return;

        const inputName = input.getAttribute('name');
        const labelToChange = this.widgetDateFormLabels.filter(
            (label) => inputName === label.getAttribute('for'),
        );

        if (input.value) {
            if (labelToChange.length) {
                labelToChange[0].classList.add('sr-only');
                input.removeAttribute('style');
            }
        } else {
            if (labelToChange.length) {
                labelToChange[0].classList.remove('sr-only');
                input.style.color = 'transparent';
            }
        }
    }
}
